/**
 * 交流合作专区 上合新闻tab - 新增资讯 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/dynamicInformation/news/page`, { params: data })
  },
  getDetail: (id, data) => {
    return request.get(`/api/frLegalPlatform/web/dynamicInformation/news/${id}`, { params: data })
  }
}
